<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            消费工单分类统计
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <div style="float:right" v-if="zoneValue.length>0">
                        <elSelectTree :options='zoneValue' accordion :props="zoneProps" placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" style="width:250px;margin-right:20px"></elSelectTree>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="elderly.name" label="老人姓名" width="85"></el-table-column>
                        <el-table-column prop="elderly.idCard" label="身份证号" width="200"></el-table-column>
                        <el-table-column prop="elderly.phone" label="手机号" width="150"></el-table-column>
                        <el-table-column prop="elderly.zoneName" label="所属区域" width="300"></el-table-column>
                        <el-table-column prop="serve.name" label="服务人员"  width="85"></el-table-column>
                        <el-table-column label="拍照图片" width="100">
                            <template slot-scope="scope">
                                 <el-popover placement="right" title="" trigger="click" v-if="scope.row.imgUrl">
                                    <img :src="imgUrl+scope.row.imgUrl+'_watermark.jpg'"  style="width: 500px"/>
                                    <img slot="reference" :src="imgUrl+scope.row.imgUrl+'_watermark.jpg'" style="width:100%">
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="打卡地址" ></el-table-column>
                        <el-table-column prop="remark" label="备注"  width="300"></el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import elSelectTree from "../../components/ElSelectTree"
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                imgUrl:this.$imgUrl,
                currentPage:1,
                zoneValue:[],
                zoneCode:'',
                th:0,
                name:'',
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
            }
        },
        components:{
            elSelectTree
        },
        created(){
            this.init();
            // this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/ListForStaff",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var data=JSON.stringify(response.data.data);
                            data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                            this.zoneValue = data;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
             getZoneValue(val){
                this.zoneCode=val
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                var zoneCode='00000000-0000-0000-0000-000000000000'
                if(this.zoneCode){
                    zoneCode=this.zoneCode
                }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/GetPageList",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        zoneCode:zoneCode
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.elderlyClockinPageInfo.list;
                        this.totalItems = response.data.data.elderlyClockinPageInfo.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },



        }
    }
</script>

<style scoped>

</style>
